export const WIDGET_MARKETING_MODAL_TITLE =
  'Is our widget right for your site?';

export const WIDGET_MARKETING_MODAL_DESCRIPTION =
  'Our widget only performs well on pages with lots of text, such as blogs & news articles. We don’t recommend implementing it on podcast or product pages.';
